import { render } from "./index.vue?vue&type=template&id=566e6bac&scoped=true&bindings={}"
import script from "./InfoCard.js?vue&type=script&lang=js"
export * from "./InfoCard.js?vue&type=script&lang=js"

import "./InfoCard.scss?vue&type=style&index=0&id=566e6bac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-566e6bac"

export default script